import { FC, ReactNode } from 'react';
import DashboardLayout from '@/layout/Dashboard';

interface MainLayoutProps {
  children?: ReactNode;
}

// Mantis dashboard layout shell. Route guards continue to gate access; this only
// wraps the routed page (passed as `children`) with the header, drawer and content area.
export const MainLayout: FC<MainLayoutProps> = ({ children }) => <DashboardLayout>{children}</DashboardLayout>;

MainLayout.defaultProps = {
	children: undefined
};
